import React, { useState } from 'react';
import BlogFormModal from './BlogFormModal';

const BlogManagement = ({ blogs, onDeleteBlog, onUpdateBlog, onAddBlog }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingBlog, setEditingBlog] = useState(null);

    const filteredBlogs = blogs.filter(blog =>
        blog.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        blog.author?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleEdit = (blog) => {
        setEditingBlog(blog);
        setIsModalOpen(true);
    };

    const handleAdd = () => {
        setEditingBlog(null);
        setIsModalOpen(true);
    };

    const handleSave = async (blogData) => {
        let result;
        if (editingBlog) {
            result = await onUpdateBlog(editingBlog.id, blogData);
        } else {
            result = await onAddBlog(blogData);
        }
        if (result.success) {
            setIsModalOpen(false);
            setEditingBlog(null);
        }
        return result;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-ZA');
    };

    return (
        <div>
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gradpath-dark flex items-center gap-2">
                    <i className="fas fa-newspaper text-gradpath-green"></i>
                    Manage Blog Posts
                </h2>
                <button
                    onClick={handleAdd}
                    className="bg-gradpath-green text-white px-4 py-2 rounded-lg hover:bg-gradpath-dark transition-all flex items-center gap-2"
                >
                    <i className="fas fa-plus"></i> Create New Post
                </button>
            </div>

            {/* Search */}
            <div className="bg-white rounded-xl p-4 mb-6">
                <input
                    type="text"
                    placeholder="Search by title or author..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-lg focus:border-gradpath-green outline-none"
                />
            </div>

            {/* Blog Table */}
            <div className="bg-white rounded-xl shadow-md overflow-x-auto">
                <table className="w-full">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Title</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Author</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Date</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Tagline</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredBlogs.map(blog => (
                            <tr key={blog.id} className="border-t border-gray-200 hover:bg-gray-50">
                                <td className="px-4 py-3 text-sm font-medium">{blog.title}</td>
                                <td className="px-4 py-3 text-sm">{blog.author}</td>
                                <td className="px-4 py-3 text-sm">{formatDate(blog.createdAt)}</td>
                                <td className="px-4 py-3 text-sm max-w-xs truncate">{blog.tagline || '-'}</td>
                                <td className="px-4 py-3 text-sm">
                                    <button
                                        onClick={() => handleEdit(blog)}
                                        className="text-blue-600 hover:text-blue-800 mr-3"
                                    >
                                        <i className="fas fa-edit"></i>
                                    </button>
                                    <button
                                        onClick={() => onDeleteBlog(blog.id)}
                                        className="text-red-600 hover:text-red-800"
                                    >
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {filteredBlogs.length === 0 && (
                    <div className="text-center py-8 text-gray-500">
                        No blog posts found
                    </div>
                )}
            </div>

            <BlogFormModal
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    setEditingBlog(null);
                }}
                onSave={handleSave}
                initialData={editingBlog}
            />
        </div>
    );
};

export default BlogManagement;